import Button from "@mui/material/Button"
import ButtonGroup from "@mui/material/ButtonGroup"
import { styled } from "@mui/material/styles"

export const TimeSliceButton = styled(Button)(({ theme }) => ({
  height: "38px",
  borderRadius: "24px",
  fontWeight: 600,
  color: theme.palette.colors.gray500,
  backdropFilter: "blur(21px)",
  border: "none",
  boxShadow: "0 12px 45px rgba(0, 0, 0, 0.15)",
  "&.active": {
    backgroundColor:
      "linear-gradient(90deg, rgba(255, 255, 255, 0.7) 3.01%, rgba(255, 255, 255, 0.5) 103.3%)",
    color: theme.palette.colors.gray700,
    boxShadow: "0px 1px 3px 0px #1018281A",
  },
  "& .MuiTouchRipple-root": {
    backgroundColor: "transparent",
  },
  "& .MuiButtonBase-root:nth-child(1)": {
    borderRadius: "24px 0 0 24px",
  },
  "& .MuiButtonBase-root:nth-child(3)": {
    borderRadius: "0 24px 24px 0",
  },
  [theme.breakpoints.only("xs")]: {
    width: "100%",
  },
}))

export default styled(ButtonGroup)(({ theme }) => ({
  [theme.breakpoints.only("xs")]: {
    width: "100%",
  },
  "& .MuiButtonBase-root": {
    border: "none",
  },
}))
